import CardWithTitle from 'components/CardWithTitle';
import React from 'react';

const ProductInfoDetail = ({ row, offerType, name, sellerName, type }) => {
  const date1 = new Date(row?.validityStartTime);
  const date2 = new Date(row?.validityExpireTime);
  const diffHours = (dt2, dt1) => {
    let diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60 * 60;
    return Math.abs(Math.round(diff));

    // const diffTime =(dt2.getTime() - dt1.getTime());

    // // calculate the number of days between two dates javascript
    // const daysDiff = diffTime / (1000 * 3600 * 24);

    // const diffTime = dt2.getTime() - dt1.getTime();

    // // calculate the number of days between hours dates javascript
    // const hoursDiff = diffTime / (1000 * 3600);

    // return hoursDiff;
  };
  //   console.log(
  //     'row.validityStartTime',
  //     check1,
  //     check2,
  //     diffhours(check2, check1)
  //   );
  return (
    <CardWithTitle title={name}>
      <div className="mb-2 pb-1">
        <span className="font-manrope text-uppercase text-gray f-10 fw-semibold d-block">
          Seller
        </span>
        <p className="font-manrope f-12 fw-medium mb-0">{sellerName}</p>
      </div>
      <div className="mb-2 pb-1">
        <span className="font-manrope text-uppercase text-gray f-10 fw-semibold d-block">
          {type}
        </span>
        <p className="font-manrope f-12 fw-medium mb-0">{offerType}</p>
      </div>
      <div className="d-inline-block f-12  mb-2 offer-time font-manrope fw-medium">
        Ends in: <span className="text-danger">{diffHours(date2, date1)}</span>
      </div>
    </CardWithTitle>
  );
};

export default ProductInfoDetail;
